import { defineAuthority, findGateInUser, gatherUserChannels, getDesignCenters, getType } from '../components/utilsDesign';

// Фейковый дизайн, в котором активированы все 64 ворот — чтобы показать сразу все каналы и ворота
// (например, в /admin/channels). Планеты, линии, цвета и тона тут условные.

const planets = [
  'Sun',
  'Earth',
  'Moon',
  'North_Node',
  'South_Node',
  'Mercury',
  'Venus',
  'Mars',
  'Jupiter',
  'Saturn',
  'Uranus',
  'Neptune',
  'Pluto',
];

const gates = Array.from({ length: 64 }, (unused, ind) => ({
  planet: planets[ind % planets.length],
  gate: ind + 1,
  line: (ind % 6) + 1,
  color: (ind % 6) + 1,
  tone: (ind % 6) + 1,
  base: (ind % 5) + 1,
  label: ind % 2 ? 'des' : 'prs',
}));

const channels = gatherUserChannels(gates).map(oneChannel => {
  const activatedWith = {};
  oneChannel.gates.forEach(gateId => {
    activatedWith[gateId] = [findGateInUser(gates, gateId)];
  });
  return { ...oneChannel, activatedWith };
});

const active_chakras = getDesignCenters(gates);

export const full_design = {
  id: 'full',
  type: getType(gates),
  auth: defineAuthority(active_chakras),
  gates,
  channels,
  active_chakras,
  split: [channels.map(oneChannel => oneChannel.id)],

  variables: {
    left_down: null,
    left_up: null,
    right_down: null,
    right_up: null
  },
  inc_cross: [],
  inc_cross_typ: '',
  profile: [],

  des: '',
  prs: '',

  personality: gates.filter(oneGate => oneGate.label === 'prs'),
  design: gates.filter(oneGate => oneGate.label === 'des'),
  meta: {
    design: '',
    personality: ''
  }
};
